<template>
  <div class="config-page">
    <div class="item-href" v-track="{ functionName: '猜你喜欢' }">
      <div class="href-txt">猜你喜欢</div>
      <van-switch :value="checked" size="20" active-color="#EB1700" :active-value="1" :inactive-value="0" @change="switchChange"/>
      <van-icon name="info-o" color="#A39992" class="icon-tip" @click="showTip('关闭猜你喜欢，将会停止接收系统推荐的内容。')"/>
    </div>
    <div class="item-href loginout" @click="isLogout = true"
         v-track="{ functionName: '注销用户' }">
      <div class="href-txt">注销用户</div>
    </div>
    <van-overlay :show="isLogout" @click="isLogout = false">
      <div class="wrap" @click.stop>
        <div class="wrap-txt">提示</div>
        <div class="wrap-con">
          您确认注销注册信息吗?注销后则无法观看平台内容再次观看需要重新实名注册!
        </div>
        <div class="warp-btn">
          <div class="btn btn1" @click="isLogout = false">取消</div>
          <div class="btn btn2" @click="handleClickLogout">确定</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {iepLogout} from '../../api/api'
import wx from 'weixin-js-sdk'
import withRouteTracking from '../../utils/withRouteTracking'
import {getActionStatusCode, updateActionStatusCode} from '../../api/person'

const UserProfile = {
  data() {
    return {
      isLogout: false,
      checked: 1
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  async mounted() {
    const res = await getActionStatusCode({
      actionCode: 1
    })
    if (res.code === 0) {
      this.checked = res.data
    }
  },
  methods: {
    showTip(txt) {
      this.$toast({
        message: txt,
        duration: 2000,
      })
    },
    async switchChange(val) {
      this.checked = val
      const res = await updateActionStatusCode({
        actionCode: 1,
        actionStatus: val
      })
      if (res.code === 0) {
        this.$toast('操作成功')
      }
    },
    handleClickLogout() {
      let params = {
        userId: this.userInfo.id
      }
      iepLogout(params).then(res => {
        this.$store.dispatch('Logout').then(res => {
          this.isLogout = false
          sessionStorage.clear()
          localStorage.clear()
          wx.ready(function () {
            wx.closeWindow() // 关闭当前页面
          })
        })
      })
    },
  }
}

export default withRouteTracking(UserProfile)

</script>

<style scoped lang="less">
.config-page {
  width: 100%;
  min-height: 100vh;
  background: #F9F8F7;
  padding: 16px;
  padding-bottom: 30px;
  box-sizing: border-box;
  overflow: hidden;

  /deep/ .van-overlay {
    z-index: 9999;

    .wrap {
      width: 320px;
      border-radius: 10px;
      background-color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 20px;
      box-sizing: border-box;

      .img-wrap {
        width: 80px;
        display: block;
        margin-bottom: 18px;
        margin-left: 50%;
        transform: translateX(-50%);
      }

      .wrap-txt {
        font-size: 17px;
        line-height: 24px;
        font-weight: 500;
        color: #000000;
        margin-bottom: 30px;
        text-align: center;

        &.wrap-txt2 {
          border-bottom: 1px solid #A9AEB6;
          padding-bottom: 10px;
          box-sizing: border-box;
          text-align: left;
          margin-bottom: 14px;
        }
      }

      .wrap-txt3 {
        position: relative;

        &::before {
          content: '*';
          font-size: 17px;
          color: #FF0000;
          width: 9px;
          text-align: center;
          display: inline-block;
        }
      }

      .wrap-con {
        color: rgb(0, 0, 0);
        font-family: PingFang SC;
        font-size: 17px;
        font-weight: 300;
        line-height: 23.8px;
        letter-spacing: 0px;
        text-align: center;
        margin: 26px 0;

        .href-txt {
          color: #EB1700;
        }
      }

      .warp-btn {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 8px;
        height: 55px;
        box-sizing: border-box;

        .btn {
          text-align: center;
          font-size: 17px;
          font-weight: 500;
          border-radius: 30pc;
          height: 42px;
          line-height: 42px;

          &.btn1 {
            color: #81766F;
            background: #F1EFED;
          }

          &.btn2 {
            background: #EB1700;
            color: #fff;
          }
        }
      }
    }
  }
}

.item-href {
  margin-bottom: 16px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0px 15px 30px 0px rgba(245, 248, 252, 0.25);
  padding: 0 14px;
  box-sizing: border-box;

  .href-icon {
    width: 23px;
    height: 23px;
    display: block;
  }

  .href-txt {
    flex: 1;
    margin-left: 11px;
    font-size: 13px;
    color: #212226;
  }

  .icon-tip {
    margin-left: 10px;
  }

  &.loginout {
    .href-txt {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #BABABA;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/person/config.vue